<div class="suggested-message">
  {{ suggestion.simple }}
</div>
